/* globals route axios */

import FormGroup from '../components/FormGroup.vue';
import ConfirmButton from '../components/ConfirmButton.vue';
import ErrorHandler from '../core/ErrorHandler';

export default {

  props: {
    model: {
      type: Object,
      default: null,
    },
    resource: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    canUpdate: {
      type: Boolean,
      required: true,
    },
    canDelete: {
      type: Boolean,
      required: true,
    },
  },

  components: { FormGroup, ConfirmButton },

  data() {
    return {
      status: null,
      statusDestroy: null,
      form: null,
    };
  },

  computed: {
    routeCreateUrl() {
      return this.isCreateForm ? route(`api.${this.resource}.store`) : null;
    },

    routeUpdateUrl() {
      return this.isUpdateForm ? route(`api.${this.resource}.update`, this.model.id) : null;
    },

    routeDeleteUrl() {
      return this.isUpdateForm ? route(`api.${this.resource}.destroy`, this.model.id) : null;
    },

    isCreateForm() {
      return this.action === 'create';
    },

    isUpdateForm() {
      return this.action === 'update';
    },

    formMethod() {
      return this.isUpdateForm ? 'patch' : 'post';
    },

    isFormDisabled() {
      return this.form.processing || (this.isUpdateForm && !this.canUpdate);
    },
  },

  created() {
    if (this.model) {
      this.form.withOptions({ resetOnSuccess: false }).populate(this.model);
    }
  },

  methods: {
    submit() {
      return this.isCreateForm ? this.create() : this.update();
    },

    create() {
      if (this.beforeCreateHook() === false) {
        return;
      }
      this.status = 'loading';
      this.form[this.formMethod](this.routeCreateUrl)
        .then(({ data }) => {
          if (this.form.successful) {
            this.$emit('created', data);
            this.$notify({ type: 'success', title: 'Succès', text: 'Créé avec succès.' });
            this.onSuccess();
          }
        })
        .catch((error) => {
          new ErrorHandler(error).dispatch();
          this.onFail();
        });
    },

    update() {
      if (this.beforeUpdateHook() === false) {
        return;
      }
      this.status = 'loading';
      this.form[this.formMethod](this.routeUpdateUrl)
        .then(({ data }) => {
          if (this.form.successful) {
            this.$emit('updated', data);
            this.$notify({ type: 'success', title: 'Succès', text: 'Mis à jour avec succès.' });
            this.onSuccess();
          }
        })
        .catch((error) => {
          new ErrorHandler(error).dispatch();
          this.onFail();
        });
    },

    destroy() {
      if (this.beforeDestroyHook() === false) {
        return;
      }
      this.statusDestroy = 'loading';
      axios
        .delete(this.routeDeleteUrl)
        .then(() => {
          this.$emit('deleted', this.model);
          this.$notify({ type: 'success', title: 'Succès', text: 'Supprimé avec succès.' });
          this.onDestroySuccess();
        })
        .catch((error) => {
          new ErrorHandler(error).dispatch();
          this.onDestroyFail();
        });
    },

    onSuccess() {
      this.status = 'succeeded';
      setTimeout(() => {
        this.status = null;
        this.afterSuccessHook();
        if (this.isUpdateForm) {
          this.$modal.close();
        }
      }, 1500);
    },

    onFail() {
      this.status = 'failed';
      setTimeout(() => {
        this.status = null;
        this.afterFailHook();
      }, 1500);
    },

    onDestroySuccess() {
      this.statusDestroy = 'succeeded';
      setTimeout(() => {
        this.statusDestroy = null;
        this.afterSuccessHook();
        this.$modal.close();
      }, 1500);
    },

    onDestroyFail() {
      this.statusDestroy = 'failed';
      setTimeout(() => {
        this.statusDestroy = null;
        this.afterFailHook();
      }, 1500);
    },

    afterSuccessHook() { },

    afterFailHook() { },

    beforeCreateHook() { },

    beforeUpdateHook() { },

    beforeDestroyHook() { },
  },
};
